import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=277c3bd5&scoped=true&"
import script from "./Proposals.vue?vue&type=script&lang=js&"
export * from "./Proposals.vue?vue&type=script&lang=js&"
import style0 from "./Proposals.vue?vue&type=style&index=0&id=277c3bd5&prod&lang=css&"
import style1 from "./Proposals.vue?vue&type=style&index=1&id=277c3bd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c3bd5",
  null
  
)

export default component.exports